import GlobalStyle from "../../styles/global";

import Header from "../Header";
import Footer from "../Footer";
import { SpaceMobile } from "../../styles/global";

function Layout({ children, headerAbsolute, token, cart_token }) {
  return (
    <div>
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1"></meta>


      <Header headerAbsolute={headerAbsolute} token={token} cart_token={cart_token} />
      <SpaceMobile></SpaceMobile>
      {children}

      <Footer />

      <GlobalStyle />
    </div>
  );
}

export default Layout;
